// Event chat and group feed payloads, plus the realtime frame shapes.
export const REACTION_KINDS = [
    'eye',
    'thumbs_up',
    'thumbs_down',
    'laugh',
    'confetti',
    'excited',
    'caring',
    'prayer',
];
/** Labels for the picker and the "who reacted" roster. */
export const REACTION_LABELS = {
    eye: 'Seen',
    thumbs_up: 'Thumbs up',
    thumbs_down: 'Thumbs down',
    laugh: 'Laughter',
    confetti: 'Celebrate',
    excited: 'Excitement',
    caring: 'Caring',
    prayer: 'Prayer',
};
export function groupChannelName(groupId) {
    return `group.${groupId}`;
}
export function eventChannelName(eventId) {
    return `event.${eventId}`;
}
/**
 * The tournament channel for an event. Keyed by EVENT id, like the URL is.
 *
 * ⚠ A THIRD family rather than riding on `event.<id>`, and the reason is the
 * silent-failure kind. The event channel's authorizer is `canAccessEventChat()`
 * -- the full per-type capability check, which can be off entirely when a group
 * has chat disabled, and is RSVP-gated on a `yes_only` event. Tournament reads
 * need only MEMBER. Riding the chat channel would therefore mean a group with
 * chat turned off gets no live re-seating at all: nothing throws, nothing logs,
 * health stays green, and the room finds out by standing around.
 *
 * The hub is channel-agnostic by design, so a new family costs one arm in
 * `parseChannel()` and one in the authorizer.
 */
export function tournamentChannelName(eventId) {
    return `tournament.${eventId}`;
}
/** Close codes the hub uses. 4001-4999 is the application range. */
export const WsCloseCode = {
    AUTH_FAILED: 4001,
    /**
     * The access token expired. Distinct from AUTH_FAILED so the client refreshes
     * and reconnects silently instead of bouncing the user to a login screen
     * mid-session.
     */
    TOKEN_EXPIRED: 4002,
};
/** How many posts per group the preview endpoint returns. Matches the PHP app. */
export const FEED_PREVIEW_PER_GROUP = 2;
//# sourceMappingURL=chat.js.map